import { render, staticRenderFns } from "./stockManagementList.vue?vue&type=template&id=1b6edb6a&scoped=true&"
import script from "./stockManagementList.vue?vue&type=script&lang=js&"
export * from "./stockManagementList.vue?vue&type=script&lang=js&"
import style0 from "./stockManagementList.vue?vue&type=style&index=0&id=1b6edb6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6edb6a",
  null
  
)

export default component.exports